import React, { ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'
import Svg from 'components/UI/SVG'
import SEOPlusIcon from 'images/seo-plus-icon.svg'
import StyledMarkdown from 'components/UI/StyledMarkdown'
import { graphql, useStaticQuery } from 'gatsby'

export default function ComponentFAQ({
  data,
  sxx,
}: {
  data: Queries.DirectusData_component_faq
  sxx?: ThemeUIStyleObject
}): ReactElement {
  const translationsData = useStaticQuery<Queries.FAQQuery>(graphql`
    query FAQ {
      directus {
        general_translations {
          strings {
            frequently_asked_questions
            languages_code {
              code
            }
          }
        }
      }
    }
  `)

  const generalTranslations = getEnglishStrings(
    translationsData?.directus?.general_translations?.strings,
  )
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '4rem',
        width: '100%',
        alignItems: 'center',
        ...sxx,
      }}
    >
      <Text as="h2" variant="text.h2Big" sx={{ textAlign: 'center' }}>
        {generalTranslations?.frequently_asked_questions}
      </Text>
      <Flex sx={{ flexDirection: 'column', gap: '1.6rem', width: '100%' }}>
        {data?.items?.map((faq, index) => (
          <FAQItem key={faq?.id ?? index} data={faq?.faq_items_id} initialIsOpen={index === 0} />
        ))}
      </Flex>
    </Flex>
  )
}

function FAQItem({
  data,
  initialIsOpen,
}: {
  data?: Queries.Maybe<Queries.DirectusData_faq_items>
  initialIsOpen: boolean
}): ReactElement {
  const strings = getEnglishStrings(data?.strings)
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '0.8rem',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <details
        open={initialIsOpen}
        sx={{
          borderRadius: '1.6rem',
          p: '1.6rem',
          minWidth: '100%',
          '&[open]': {
            backgroundColor: 'white05',
            '#vertical': {
              display: 'none',
            },
          },
          ':not([open]) .faq-question': {
            color: 'white80',
          },
        }}
      >
        <summary
          sx={{
            // '::marker': {
            //   display: 'none',
            // },
            '::-webkit-details-marker': {
              display: 'none',
            },
            listStyle: 'none',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Text className="faq-question" as="h3" sx={{ variant: 'text.h3Big' }}>
            {strings?.question}
          </Text>
          <Svg sx={{ flexShrink: 0 }} svg={SEOPlusIcon} />
        </summary>
        <StyledMarkdown sxx={{ variant: 'text.paragraphSmallRegular', mt: '0.8rem' }}>
          {strings?.answer}
        </StyledMarkdown>
      </details>
    </Flex>
  )
}
